<div class="cv-templates" *ngIf="selectedCv==null">
    <div class="cv-card" *ngFor="let cv of evaluatedCvs; let i = index">
        <img [src]="getImagePath(cv)" alt="{{ 'common.cvTemplate' | translate }} {{ i + 1 }}">
        <div class="buttons">
            <button class="view-evaluation" (click)="getCvScanDetails(cv)">
                {{'View Evaluation' | translate}}
            </button>
        </div>

    </div>

</div>
<div class="cv-evaluation-details" *ngIf="selectedCv!==null">

    <app-cv-evaluation [selectedCv]="selectedCv"></app-cv-evaluation>

</div>